console.log("JS estimated-delivery-custom.js loaded!");

document.addEventListener('DOMContentLoaded', function() {
  console.log("DOMContentLoaded fired");

  const app             = document.getElementById('estimated-delivery-app');
  if (!app) return;

  const warehouseZip    = app.dataset.warehouseZip  || '';
  const cutoffTime      = app.dataset.cutoff        || '15:00';
  const maxDays         = parseInt(app.dataset.maxdays, 10) || 1;

  const edLocationLine  = app.querySelector('#ed-location-line');
  const edOrderLine     = app.querySelector('#ed-order-line');
  const edDeliveryLine  = app.querySelector('#ed-delivery-line');
  const edForm          = app.querySelector('#ed-zip-form');
  const edInput         = app.querySelector('#ed-zip-input');
  const edError         = app.querySelector('#ed-error-message');

  let clientZip = window.localStorage.getItem('ed_zip') || '';
  let formOpen  = false;

  // UPS Ground average transit days by state (from NJ origin)
  const stateTransitDays = {
    // 1 business day
    NJ:2, NY:2,
    // 2 business days
    CT:3, PA:3, DE:3, MD:3, VA:3, WV:3, OH:3, DC:3,
    MA:3, RI:3, NH:3, VT:3,
    // 3 business days
    ME:4, MI:4, IN:4, KY:4, TN:4, NC:4, SC:4, GA:4, FL:4,
    AL:4, MS:4, LA:4, AR:4, MO:4, IL:4, WI:4, MN:4, IA:4,
    // 4 business days
    ND:5, SD:5, NE:5, KS:5, OK:5,
    CO:5, NM:5, AZ:5, UT:5, NV:5, TX:5,
    // 5 business days
    CA:6, OR:6, WA:6, ID:6, MT:6, WY:6,
    // remote
    AK:8, HI:8
  };

  function getCustomerZip() {
    try {
      if (window.Shopify &&
          Shopify.customer &&
          Shopify.customer.default_address &&
          Shopify.customer.default_address.zip) {
        return Shopify.customer.default_address.zip;
      }
    } catch (e) {}
    return '';
  }

  function getMinutesUntilNextCutoff(cutoff) {
    const now = new Date();
    const [h, m] = cutoff.split(':').map(Number);
    let c = new Date(now);
    c.setHours(h, m, 0, 0);

    if (now < c) return Math.floor((c - now) / 1000 / 60);
    let nxt = new Date(now);
    nxt.setDate(nxt.getDate() + 1);
    nxt.setHours(h, m, 0, 0);
    return Math.floor((nxt - now) / 1000 / 60);
  }

  function getShipDate(cutoff) {
    const now = new Date();
    const [h, m] = cutoff.split(':').map(Number);
    let ship = new Date(now);

    if (now.getHours() > h || (now.getHours() === h && now.getMinutes() >= m)) {
      ship.setDate(ship.getDate() + 1);
    }
    while (ship.getDay() === 0 || ship.getDay() === 6) {
      ship.setDate(ship.getDate() + 1);
    }
    return ship;
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        added++;
      }
    }
    return result;
  }

  function renderOrderWithin() {
    const now = new Date();
    const dow = now.getDay();
    if (dow === 0 || dow === 6) {
      edOrderLine.innerHTML = `Ships <strong style="color:#407F32;">Monday</strong>`;
      return;
    }
    const mins = getMinutesUntilNextCutoff(cutoffTime);
    if (mins <= 0) {
      edOrderLine.innerHTML = '';
      return;
    }
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    edOrderLine.innerHTML =
      `Order within <strong style="color:#407F32;">${h} hrs ${m} mins.</strong>`;
  }

  function renderArrow(open) {
    return `
      <span style="
        display: inline-block;
        transform: rotate(${open ? 180 : 0}deg);
        margin-left: 2px;
        transition: .18s;
        width: 12px;   /* w-3 ≈ 12px */
        height: 12px;  /* h-3 ≈ 12px */
        color: #034b55; /* reemplaza por tu color “nuts-cyan-800” */
      ">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          style="width:100%; height:100%; display:block;"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    `;
  }

  function fetchLocationByZip(zip) {
    return fetch(`https://api.zippopotam.us/us/${zip}`)
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data && data.places && data.places.length) {
          return {
            city: data.places[0]['place name'],
            state: data.places[0]['state abbreviation']
          };
        }
        return { city:'', state:'' };
      })
      .catch(() => ({ city:'', state:'' }));
  }

  function showLocation(zip, city) {
    edLocationLine.innerHTML = `
      <a href="#" id="ed-location-link">
        ${ city ? `${city} - ${zip}` : zip } ${ renderArrow(formOpen) }
      </a>
    `;
    document.getElementById('ed-location-link').onclick = e => {
      e.preventDefault();
      formOpen = !formOpen;
      edForm.classList.toggle('hidden-zip', !formOpen);
      showLocation(zip, city);
      if (formOpen) edInput.focus();
    };
    if (!formOpen) edForm.classList.add('hidden-zip');
    edInput.value = zip;
  }

  async function render() {
    edError.textContent = '';
    renderOrderWithin();

    const shopZip = getCustomerZip();
    let zip = clientZip || shopZip;

    if (zip) {
      const { city, state } = await fetchLocationByZip(zip);
      showLocation(zip, city);

      const transitDays = stateTransitDays[state] || maxDays;
      const now         = new Date();
      const shipDate    = getShipDate(cutoffTime);
      const deliverDate = addBusinessDays(shipDate, transitDays);

      const oneDayMs = 24 * 60 * 60 * 1000;
      let deliveryText;
      if (deliverDate - now >= oneDayMs && deliverDate - now < 2 * oneDayMs) {
        deliveryText = 'Tomorrow';
      } else {
        deliveryText = deliverDate.toLocaleDateString('en-US', {
          weekday: 'short',
          month:   'short',
          day:     'numeric'
        });
      }

      edDeliveryLine.innerHTML = `
                                <span class="ed-delivery-line-text">
                                  Estimated delivery by <strong>${deliveryText}</strong>
                                </span>
                              `;
      formOpen = false;
      edForm.classList.add('hidden-zip');
    } else {
      edLocationLine.innerHTML   = `<span>Please enter your ZIP code</span>`;
      edDeliveryLine.textContent = '';
      edForm.classList.remove('hidden-zip');
      edInput.value               = '';
      formOpen                    = true;
    }
  }

  if (!clientZip) {
    fetch('https://ipapi.co/json/')
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => {
        const geoZip = data.postal;
        if (/^[0-9]{5}$/.test(geoZip)) {
          clientZip = geoZip;
          localStorage.setItem('ed_zip', geoZip);
          formOpen = false;
          edForm.classList.add('hidden-zip');
          render();
        }
      })
      .catch(() => console.warn('Could not get ZIP via IPAPI'));
  }

  edForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const val = edInput.value.trim();
    if (/^[0-9]{5}$/.test(val)) {
      edError.textContent = '';
      clientZip = val;
      localStorage.setItem('ed_zip', val);
      formOpen = false;
      render();
    } else {
      edError.textContent = 'Please enter a valid ZIP code.';
      edInput.style.borderColor = '#EC6286';
      edInput.focus();
    }
  });

  render();
  window.addEventListener('resize', render);
});
